import gql from 'graphql-tag';

const photoAttributionDetails = gql`
  fragment photoAttributionDetails on PhotoAttribution {
    name
    username
    organization_name
    avatar_photo {
      id
      thumbnail_urls {
        url
        size_code
        width
        height
      }
    }
    account_id
  }
`;

export default photoAttributionDetails;
